__turbopack_context__.v({
  "shoeWidthTitle": "SizeBucketRefinement-module-scss-module__0YUfEG__shoeWidthTitle",
  "sizeDropdownContainer": "SizeBucketRefinement-module-scss-module__0YUfEG__sizeDropdownContainer",
  "sizePanelContainer": "SizeBucketRefinement-module-scss-module__0YUfEG__sizePanelContainer",
});
